
export default {
	name: 'Modal',
	components: {
	}, 
  mixins: [
  ],
	props: [
	],
	data() {
		return {
			show: false
		};
	},
	methods: {
		closeModal() {
			this.show = false;
			document.querySelector("body").classList.remove("overflow-hidden");
		},
		openModal() {
			this.show = true;
			document.querySelector("body").classList.add("overflow-hidden");
		}
		
	},
	mounted() {
		
	}

};